import React, { useEffect, useMemo, useState } from 'react';

import { getRandomString } from 'utils/';
import { FlexCol, FlexRow } from 'components/Layout/';
import DatePicker from 'components/DatePicker/DatePicker';
import { StyledCaption } from 'components/Item/Detail/Detail.styled';
import { SelectInput, TextArea, TextInput } from 'components/Inputs/';

function Detail({
  tags,
  state,
  errors,
  itemSKU,
  itemTag,
  setState,
  isReadOnly,
  onDateChange,
  onInputChange,
}) {
  const invalid = ['', null, 'null', undefined];
  const [tagOption, setTagOption] = useState(null);
  const sku = invalid.includes(state.sku) ? '' : state.sku;
  const buttonText = invalid.includes(itemSKU) ? 'Generate' : '';

  const tagOptions = useMemo(() => {
    return [...tags].map(function ({ id, tagname }) {
      return {
        value: id,
        label: tagname,
      };
    });
  }, [tags]);

  /**
   * @param {{
   * label: string
   * value: string
   * }} option
   */
  function onTagChange(option) {
    let tag = null;
    setTagOption(option);
    if (option) {
      const { value } = option;
      tag = value;
    }
    setState({
      ...state,
      tag,
    });
  }

  function onGenerateSku() {
    const sku = getRandomString({ length: 13, prefix: 'W-', upperCase: true });
    setState({
      ...state,
      sku,
    });
  }

  useEffect(() => {
    if (itemTag && tagOptions) {
      const tag = [...tagOptions].find(function ({ value }) {
        return value === itemTag;
      });
      if (tag) {
        onTagChange(tag);
      }
    }
  }, [itemTag, tagOptions]);

  return (
    <>
      <FlexRow>
        <FlexCol flexWidth={12}>
          <StyledCaption>More Details</StyledCaption>
        </FlexCol>
      </FlexRow>
      <FlexRow>
        <FlexCol flexWidth={4}>
          <FlexRow>
            <FlexCol flexWidth={12}>
              <TextInput
                name="sku"
                value={sku}
                inputId="sku"
                caption="SKU"
                inputType="text"
                disabled={isReadOnly}
                buttonText={buttonText}
                onClick={onGenerateSku}
                onChange={onInputChange}
                placeholder="e.g W-3435638"
              />
            </FlexCol>
          </FlexRow>
          <FlexRow>
            <FlexCol flexWidth={12}>
              <TextArea
                height={35}
                inputType="text"
                name="description"
                inputId="description"
                caption="Description"
                disabled={isReadOnly}
                onChange={onInputChange}
                value={state.description}
                placeholder="Enter description"
                description="More details to describe the item"
              />
            </FlexCol>
          </FlexRow>
          <FlexRow>
            <FlexCol flexWidth={12}>
              <TextInput
                inputType="text"
                name="manufacturer"
                disabled={isReadOnly}
                inputId="manufacturer"
                caption="Manufacturer"
                onChange={onInputChange}
                value={state.manufacturer}
                placeholder="Enter manufacturer"
                description="Who made this item"
                errorMessage={errors.manufacturer}
              />
            </FlexCol>
          </FlexRow>
        </FlexCol>
        <FlexCol flexWidth={4}>
          <FlexRow>
            <FlexCol flexWidth={12}>
              <DatePicker
                name="warrantyExpiry"
                disabled={isReadOnly}
                inputId="warrantyExpiry"
                caption="Warranty Expiry"
                selected={state.warrantyExpiry}
                placeholder="Select warranty expiry"
                errorMessage={errors.warrantyExpiry}
                onChange={onDateChange.bind(null, 'warrantyExpiry')}
                description="Enter number of days item will be under warranty once sold"
              />
            </FlexCol>
          </FlexRow>
          <FlexRow>
            <FlexCol flexWidth={12}>
              <DatePicker
                name="purchaseDate"
                disabled={isReadOnly}
                inputId="purchaseDate"
                caption="Purchase Date"
                selected={state.purchaseDate}
                placeholder="Select purchase date"
                errorMessage={errors.purchaseDate}
                onChange={onDateChange.bind(null, 'purchaseDate')}
              />
            </FlexCol>
          </FlexRow>
        </FlexCol>
        <FlexCol flexWidth={4}>
          <FlexRow>
            <FlexCol flexWidth={12}>
              <DatePicker
                name="productionDate"
                disabled={isReadOnly}
                inputId="productionDate"
                caption="Production Date"
                selected={state.productionDate}
                placeholder="Select production date"
                errorMessage={errors.productionDate}
                onChange={onDateChange.bind(null, 'productionDate')}
              />
            </FlexCol>
          </FlexRow>
          <FlexRow>
            <FlexCol flexWidth={12}>
              <SelectInput
                name="tag"
                caption="Tag"
                isLoading={false}
                value={tagOption}
                isClearable={true}
                isSearchable={true}
                ariaLabelledBy="tag"
                options={tagOptions}
                disabled={isReadOnly}
                onChange={onTagChange}
                placeholder="Select tag"
                errorMessage={errors.tag}
                menuPortalTarget={window.document.body}
              />
            </FlexCol>
          </FlexRow>
        </FlexCol>
      </FlexRow>
    </>
  );
}

export default Detail;
